import * as React from 'react';
import { Helper } from '../../../../Helper';
import { IComposerImage } from '../../../../interfaces/IComposerImage';
import { Environment } from '../../../../services/Environment';
import { LocalizationService } from '../../../../services/LocalizationService';
import { IAIcon } from '../../../icon/Icon';
import * as styles from './Collage.css';

export interface IProps {
  images: IComposerImage[];
  token: string;
  environment: "Development" | "Test" | "Production";
  tenant: string;
  maxImages: number;
  editMode: boolean;
  bordeRadius?: number;
  openImageViewer: (index: number) => void;
}

export interface IState {
}

export class Collage extends React.Component<IProps, IState> {

  private readonly localizationService: LocalizationService = new LocalizationService();

  constructor(props: IProps) {
    super(props);
    this.state = {
    };
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
  }

  private getGridAreaForIndex(index: number): string {
    console.log(index);
    switch (this.props.maxImages <= this.props.images.length ? this.props.maxImages : this.props.images.length) {
      case 1:
        return "1 / 1 / 1 / 2"
      case 2:
        if (index === 1) {
          return "1 / 1 / 1 / 1"
        }
        if (index === 2) {
          return "1 / 2 / 1 / 2"
        }
      case 3:
        if (index === 1) {
          return "1 / 1 / 2 / 1"
        }
        if (index === 2) {
          return "2 / 1 / 3 / 1"
        }
        if (index === 3) {
          return "1 / 2 / 3 / 2"
        }
      case 4:
        if (index === 1) {
          return "1 / 1 / 3 / 1"
        }
        if (index === 2) {
          return "3 / 1 / 3 / 1"
        }
        if (index === 3) {
          return "1 / 2 / 2 / 2"
        }
        if (index === 4) {
          return "2 / 2 / 4 / 2"
        }
      case 5:
        if (index === 1) {
          return "1 / 1 / 3 / 1"
        }
        if (index === 2) {
          return "3 / 1 / 3 / 1"
        }
        if (index === 3) {
          return "1 / 2 / 2 / 2"
        }
        if (index === 4) {
          return "2 / 2 / 4 / 2"
        }
        if (index === 5) {
          return "4 / 1 / 5 / 3"
        }
      case 6:
        if (index === 1) {
          return "1 / 1 / 3 / 1"
        }
        if (index === 2) {
          return "3 / 1 / 3 / 1"
        }
        if (index === 3) {
          return "1 / 2 / 2 / 2"
        }
        if (index === 4) {
          return "2 / 2 / 4 / 2"
        }
        if (index === 5) {
          return "4 / 1 / 5 / 1"
        }
        if (index === 6) {
          return "4 / 2 / 5 / 2"
        }
      case 7:
        if (index === 1) {
          return "1 / 1 / 3 / 1"
        }
        if (index === 2) {
          return "3 / 1 / 3 / 1"
        }
        if (index === 3) {
          return "1 / 2 / 2 / 2"
        }
        if (index === 4) {
          return "2 / 2 / 4 / 2"
        }
        if (index === 5) {
          return "4 / 1 / 5 / 1"
        }
        if (index === 6) {
          return "5 / 1 / 6 / 1"
        }
        if (index === 7) {
          return "4 / 2 / 6 / 2"
        }
      case 8:
        if (index === 1) {
          return "1 / 1 / 3 / 1"
        }
        if (index === 2) {
          return "3 / 1 / 3 / 1"
        }
        if (index === 3) {
          return "1 / 2 / 2 / 2"
        }
        if (index === 4) {
          return "2 / 2 / 4 / 2"
        }
        if (index === 5) {
          return "4 / 1 / 6 / 1"
        }
        if (index === 6) {
          return "6 / 1 / 6 / 1"
        }
        if (index === 7) {
          return "4 / 2 / 5 / 2"
        }
        if (index === 8) {
          return "5 / 2 / 7 / 2"
        }
      case 9:
        if (index === 1) {
          return "1 / 1 / 3 / 1"
        }
        if (index === 2) {
          return "3 / 1 / 3 / 1"
        }
        if (index === 3) {
          return "1 / 2 / 2 / 2"
        }
        if (index === 4) {
          return "2 / 2 / 4 / 2"
        }
        if (index === 5) {
          return "4 / 1 / 6 / 1"
        }
        if (index === 6) {
          return "6 / 1 / 6 / 1"
        }
        if (index === 7) {
          return "4 / 2 / 5 / 2"
        }
        if (index === 8) {
          return "5 / 2 / 7 / 2"
        }
        if (index === 9) {
          return "7 / 1 / 7 / 3"
        }
      case 10:
        if (index === 1) {
          return "1 / 1 / 3 / 1"
        }
        if (index === 2) {
          return "3 / 1 / 3 / 1"
        }
        if (index === 3) {
          return "1 / 2 / 2 / 2"
        }
        if (index === 4) {
          return "2 / 2 / 4 / 2"
        }
        if (index === 5) {
          return "4 / 1 / 6 / 1"
        }
        if (index === 6) {
          return "6 / 1 / 6 / 1"
        }
        if (index === 7) {
          return "4 / 2 / 5 / 2"
        }
        if (index === 8) {
          return "5 / 2 / 7 / 2"
        }
        if (index === 9) {
          return "7 / 1 / 7 / 1"
        }
        if (index === 10) {
          return "7 / 2 / 7 / 3"
        }
      default:
        return "1 / 1 / 1 / 2"
    }
  }

  private getGridTemplateRows(): string {
    switch (this.props.maxImages <= this.props.images.length ? this.props.maxImages : this.props.images.length) {
      case 1:
        return "250px";
      case 2:
        return "170px";
      case 3:
        return "170px 120px";
      case 4:
        return "120px 120px 120px";
      case 5:
        return "120px 120px 120px 250px";
      case 6:
        return "120px 120px 120px 170px";
      case 7:
        return "120px 120px 120px 170px 120px";
      case 8:
        return "120px 120px 120px 120px 120px 120px";
      case 9:
        return "120px 120px 120px 120px 120px 120px 250px";
      case 10:
        return "120px 120px 120px 120px 120px 120px 170px";
      default:
        return "250px";
    }
  }

  public render(): JSX.Element {
    let gridTemplateColumns = this.props.images.length === 1 ? "auto" : "auto auto";
    let width;
    if (document.getElementById("IA_collage")) {
      const rotator: any = document.getElementById("IA_collage");
      width = rotator.clientWidth;
    } else {
      setTimeout(() => {
        this.forceUpdate();
      }, 100);
    }
    const images = [];
    if (width) {
      this.props.images.forEach((image: IComposerImage, index) => {
        if (this.props.maxImages > index) {
          images.push(
            <div
              key={`image_${image.name}`}
              className={styles.IA_collageImageWrapper}
              style={{
                gridArea: this.getGridAreaForIndex(index + 1)
              }}
            >
              <div className={styles.IA_collageImageSpinner}>
                <IAIcon
                  title="Spinner"
                  size={20}
                  color={"#999999"}
                />
              </div>
              <div
                className={styles.IA_collageImage}
                style={{
                  borderRadius: this.props.bordeRadius ?? 0,
                  backgroundImage: `url("${Helper.getImageFromApiWhenOutsideSharepoint(Environment.getEnvironmentForImageAPI(this.props.environment), this.props.tenant, this.props.token, image.url, image.modified, "Full")}")`
                }}
                onClick={() => !this.props.editMode ? this.props.openImageViewer(index) : {}}
              />
            </div>
          );
        }
      });
    }
    return (
      <div>
        <div
          id={"IA_collage"}
          className={styles.IA_collage}
          style={{
            gridTemplateColumns: gridTemplateColumns,
            gridTemplateRows: this.getGridTemplateRows()
          }}
        >
          {images}
        </div >
        {this.props.images.length - this.props.maxImages > 0 &&
          <div
            className={styles.IA_moreImages}
            onClick={() => this.props.openImageViewer(this.props.maxImages)}
          >
            <IAIcon
              title="ImageGallery"
              size={24}
              color={"#ffffff"}
              onClick={() => { }}
              style={{
                float: "left",
                cursor: "pointer",
                marginRight: 6,
                height: 20,
                marginTop: -2
              }} />
            {this.props.images.length - this.props.maxImages === 1 ? this.localizationService.strings.Composer_OneMoreImage : `${this.props.images.length - this.props.maxImages} ${this.localizationService.strings.Composer_MoreImages}`}
          </div>
        }
      </div>
    );
  }
}